import { format } from 'date-fns';

export const formatDate = (dateString: string,formatString: string = 'dd/MM/yy hh:mm a') => format(new Date(dateString), formatString);